import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PricingListComponent} from './pricing-list.component';

import {AuthGuard} from '@app/shared';
import {AddPriceComponent} from '@app/modules/pricing-list/add-price/add-price.component';
import {PriceListComponent} from '@app/modules/pricing-list/price-list/price-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '', component: PricingListComponent
      },
      {
        path: 'add-price',
        loadComponent: () => AddPriceComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-price'}
      },
      {
        path: 'price-list',
        loadComponent: () => PriceListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/price-list'}
      },

    ],
    runGuardsAndResolvers: 'always',
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PricingListRoutingModule {
}
